import type { DLPPolicy } from "@whatslly/types/dlp/DLPPolicy";
import type { IPolicyStore } from "../shared/stores/IPolicyStore";
export interface IDLPStore extends IPolicyStore<DLPPolicy> {
  isDlpEnabled: boolean;
  policiesSearchTerm: string;
  rulesSearchTerm: string;

  setPoliciesSearchTerm(term: string): void;
  setRulesSearchTerm(term: string): void;
  getPolicyById(policyId: string): Promise<DLPPolicy | undefined>;
  savePolicy(policy: DLPPolicy, isEditMode?: boolean): Promise<void>;
  importConfigs(): Promise<void>;
}

export const InjectDLPStore = Symbol.for("DLPStore");
